var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import Icon from "components/icon";
import { StyledErrorHeader, StyledErrorText, } from "components/mobile_pay/views/error_page";
export var StyledWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 50%;\n  margin: auto;\n\n  padding: 50px 35px;\n\n  text-align: center;\n\n  > .icon-wrapper svg.receipt-ghost {\n    width: 100px;\n    height: 96px;\n  }\n"], ["\n  width: 50%;\n  margin: auto;\n\n  padding: 50px 35px;\n\n  text-align: center;\n\n  > .icon-wrapper svg.receipt-ghost {\n    width: 100px;\n    height: 96px;\n  }\n"])));
export default function ErrorPage() {
    return (React.createElement(StyledWrapper, null,
        React.createElement(Icon, { type: "receipt-ghost" }),
        React.createElement(StyledErrorHeader, null, "Sorry!"),
        React.createElement(StyledErrorText, null, "Digital gift card purchase is not currently available at this venue. For more information, please reach out to the venue directly.")));
}
var templateObject_1;
